import Layout from "../../components/layout";
import PageHeading from "../../components/page-header";
import LogoSlider from "../../components/logo-slider";

import fs from 'fs';
import path from 'path';

export async function getStaticProps() {
  const dir = path.join(process.cwd(), 'public/images/companies');
  const files = fs.readdirSync(dir);
  const logos = files.map((file) => `/images/companies/${file}`);

  return {
    props: { logos },
  };
}


const settings = {
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: true,
  infinite:true,
  dots: false,
  pauseOnHover: false,
  variableWidth: true,
  centerMode: true,
  centerPadding: "60px",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
};

export default function About ({ logos }) {
  return (
      <Layout>
        <PageHeading heading_text='About Us'/>

        <div className="section black-bg">
          <div className="container">
          <div className="row g-5 justify-content-center align-items-center">
            <div className="col-md-5 col-12">
                      <div className="heading-frame">
                        <div className="border-frame tr"></div>

                        <h2 className="text-right">Empowering Environments Through Seamless AV Innovation.</h2>

                        <div className="border-frame bl"></div>
                      </div>
                </div>
                <div className="col-md-5 col-12">
                        <h5 className="section-title">WHO ARE WE?</h5>
                        <p className="section-description">Founded in 2014, PROSLV is a specialist in integrated sound, lighting, and video systems. From corporate spaces and educational institutions to hospitality, worship, and government environments, we design and deliver intelligent solutions that are seamless, scalable, and built to perform.
                           <br/> <br/>
                           Driven by innovation and grounded in precision engineering, we turn complex AV challenges into elegant, easy-to-use systems. We don’t just install hardware—we engineer experiences.
                        </p>
                </div>
            </div>
          </div>
        </div>

          <div className="section">
          <div className="container">
          <div className="row g-5 justify-content-center align-items-center">
                <div className="col-md-5 col-12">
                        <h5 className="section-title">VISION</h5>
                        <p className="section-description">To be the leading partner in intelligent audio-visual integration—transforming spaces with innovative, reliable, and intuitive solutions that empower people, elevate environments, and set new standards in performance and service.
                        </p>
                </div>
                
                            <div className="col-md-5 col-12">
                      <div className="heading-frame">
                        <div className="border-frame tr"></div>

                        <h2 className="text-right">Beyond Technology. Powered by Partnership.</h2>

                        <div className="border-frame bl"></div>
                      </div>
                </div>
            </div>
          </div>
        </div>

         <div className="section black-bg">
          <div className="container">
          <div className="row g-5 justify-content-center align-items-center">
            <div className="col-md-5 col-12">
                      <div className="heading-frame">
                        <div className="border-frame tr"></div>

                        <h2 className="text-right">Empowering Spaces. Elevating Experiences.</h2>

                        <div className="border-frame bl"></div>
                      </div>
                </div>
                <div className="col-md-5 col-12">
                        <h5 className="section-title">Mission</h5>
                        <p className="section-description">At PROSLV, our mission is to design and deliver seamless, cutting-edge sound, lighting, and video solutions that elevate every experience.
                           <br/> <br/>
                           We go beyond technology—fostering true partnerships where vision becomes reality through shared expertise, proactive collaboration, precision engineering, and an unwavering commitment to service excellence.
                        </p>
                </div>
            </div>
          </div>
        </div>

        {/* <div class="team-section">
    <h2 class="highlight-title">Meet Our Team</h2>
    <div class="team-grid container">
      <div class="team-member">
        <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="Team Member" />
        <div class="team-member-info">
          <h4>Larry Zuniega</h4>
          <p>Managing Director</p>
        </div>
      </div>
      <div class="team-member">
        <img src="https://randomuser.me/api/portraits/men/45.jpg" alt="Team Member" />
        <div class="team-member-info">
          <h4>John Smith</h4>
          <p>CTO</p>
        </div>
      </div>
      <div class="team-member">
        <img src="https://randomuser.me/api/portraits/women/46.jpg" alt="Team Member" />
        <div class="team-member-info">
          <h4>Emily White</h4>
          <p>Design Lead</p>
        </div>
      </div>
      <div class="team-member">
        <img src="https://randomuser.me/api/portraits/men/47.jpg" alt="Team Member" />
        <div class="team-member-info">
          <h4>Robert Black</h4>
          <p>Developer</p>
        </div>
      </div>
    </div>
  </div> */}


  <div className="section black-bg client-section container">

    <LogoSlider logos={logos}/>
  </div>
      </Layout>
  );
}
